let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8WMbP")).then(() => parcelRequire('47py6'));